import {createSlice} from '@reduxjs/toolkit'

const initialAssetState = {
  asset: null,
  assetsDropdown: [],
  isAssetLimitReachedDialog: false,
}

export const AssetSlices = createSlice({
  name: 'assets',
  initialState: initialAssetState,
  reducers: {
    asset: (state, action) => {
      state.asset = action.payload.asset
    },
    assetsDropdown: (state, action) => {
      state.assetsDropdown = action.payload.assets
    },
    setAssetLimitReachedDialog: (state, action) => {
      state.isAssetLimitReachedDialog = action.payload
    },
    resetAsset: (state) => {
      state.asset = null
    }
  },
})
